import generalSection from "../_section/section.class";
import {adminSalaryCertUpload, userSalaryCertUpload} from "./upload";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";
import problem from "../_section/section-problem.class";
import {legacyIncome} from "../../../../../components/client/application-stages/_common/lender-tests/useXlsTests";
import {toleranceDifference} from "../../../../../api-functions/functions";
import {adminPayslipSection} from "../payslip/section";
import {adminEDSSection} from "../employment-detail-summary/section";
import {convertHtmlToPlainText} from "../../../../../../assets/scripts/string-functions";

export class userSalaryCertSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userSalaryCertUpload);
        // Add missing date error
    }
}

export class adminSalaryCertSection extends userSalaryCertSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminSalaryCertUpload);

        this.DataForm = DataForm

        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.getProblems())
        this.ApplicationForm = ApplicationForm

    }

    getProblems() {
        const problems = this.problemsList.singleUploadUserProblems();
        if (!problems.length && this.activeUpload?.allValuesAnswered) {
            const uploadData = this.activeUpload?.values
            let legacy = legacyIncome(this.mortgage)
            let applicationData = []
            let job = null
            if (legacy) {
                job = this.mortgage[`applicant${this.applicant}`].income
                if (job?.overtime) {
                    applicationData.push({
                        name: "overtime",
                        amount: job.overtime,
                        guaranteed: false
                    })
                }
                if (job.bonus) {
                    applicationData.push({
                        name: "bonus",
                        amount: job.bonus,
                        guaranteed: false
                    })
                }
                if (job.commission) {
                    applicationData.push({
                        name: "commission",
                        amount: job.commission,
                        guaranteed: false
                    })
                }

            } else {
                job = this.mortgage[`applicant${this.applicant}`].employmentIncome.find(it => it.id === this.index)
                applicationData = job.incomes || []
            }


            const shiftAllowance = applicationData.find(it => it.name === "shiftAllowance")
            const carAllowance = applicationData.find(it => it.name === "carAllowance")
            const otherAllowance = applicationData.find(it => it.name === "otherAllowance")
            const overtime = applicationData.find(it => it.name === "overtime")
            const commission = applicationData.find(it => it.name === "commission")
            const bonus = applicationData.find(it => it.name === "bonus")

            const createErrorForMismatchData = (name, applicationData, uploadData, tolerance) => {
                tolerance = tolerance ? tolerance : 5
                const check = (orig, upload, str) => {

                    if (typeof orig === 'number' && !isNaN(orig) && typeof upload === 'number' && !isNaN(upload)) {
                        let difference = toleranceDifference(orig, upload, tolerance)
                        if (difference) {
                            let way = difference < 0 ? "less" : "more"
                            problems.push(new problem({
                                type: "BUNDLE",
                                title: 'Data Mismatch',
                                message: `Application ${str} doesnt match the upload`,
                                uploadIDs: [this.activeUpload.id]
                            }))
                        }
                    }
                }

                if (typeof applicationData === 'object' && applicationData != null) {
                    Object.keys(applicationData).forEach(key => {
                        check(applicationData[key], uploadData[key], `${name}: ${key}`)
                    })
                } else {
                    check(applicationData, uploadData, name)
                }

            }

            createErrorForMismatchData("Gross Basic", job.grossBasic, uploadData.grossBasic)
            createErrorForMismatchData("Car Allowance", {
                "Last Year": carAllowance?.yearMostRecent || carAllowance?.amount,
                "Year Before": carAllowance?.yearBefore,
                "Year Before That": carAllowance?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.carAllowanceYearMostRecent,
                "Year Before": uploadData?.carAllowanceYearBefore,
                "Year Before That": uploadData?.carAllowanceYearBeforeThat,
            })
            createErrorForMismatchData("Shift Allowance", {
                "Last Year": shiftAllowance?.yearMostRecent || shiftAllowance?.amount,
                "Year Before": shiftAllowance?.yearBefore,
                "Year Before That": shiftAllowance?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.shiftAllowanceYearMostRecent,
                "Year Before": uploadData?.shiftAllowanceYearBefore,
                "Year Before That": uploadData?.shiftAllowanceYearBeforeThat,
            })
            createErrorForMismatchData("Other Allowance", {
                "Last Year": otherAllowance?.yearMostRecent || otherAllowance?.amount,
                "Year Before": otherAllowance?.yearBefore,
                "Year Before That": otherAllowance?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.otherAllowanceYearMostRecent,
                "Year Before": uploadData?.otherAllowanceYearBefore,
                "Year Before That": uploadData?.otherAllowanceYearBeforeThat,
            })
            createErrorForMismatchData("Overtime", {
                "Last Year": overtime?.yearMostRecent || overtime?.amount,
                "Year Before": overtime?.yearBefore,
                "Year Before That": overtime?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.overtimeYearMostRecent,
                "Year Before": uploadData?.overtimeYearBefore,
                "Year Before That": uploadData?.overtimeYearBeforeThat,
            })
            createErrorForMismatchData("Commission", {
                "Last Year": commission?.yearMostRecent || commission?.amount,
                "Year Before": commission?.yearBefore,
                "Year Before That": commission?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.commissionYearMostRecent,
                "Year Before": uploadData?.commissionYearBefore,
                "Year Before That": uploadData?.commissionYearBeforeThat,
            })
            createErrorForMismatchData("Bonus", {
                "Last Year": bonus?.yearMostRecent || bonus?.amount,
                "Year Before": bonus?.yearBefore,
                "Year Before That": bonus?.yearBeforeThat,
            }, {
                "Last Year": uploadData?.bonusYearMostRecent,
                "Year Before": uploadData?.bonusYearBefore,
                "Year Before That": uploadData?.bonusYearBeforeThat,
            })
            if (commission?.guaranteed && (commission?.yearMostRecent || commission?.amount) && !uploadData?.commissionGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Commission is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }
            if (carAllowance?.guaranteed && (carAllowance?.yearMostRecent || carAllowance.amount) && !uploadData?.carAllowanceGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Car Allowance is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }
            if (shiftAllowance?.guaranteed && (shiftAllowance?.yearMostRecent || shiftAllowance.amount) && !uploadData?.shiftAllowanceGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Shift Allowance is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }
            if (otherAllowance?.guaranteed && (otherAllowance?.yearMostRecent || otherAllowance.amount) && !uploadData?.otherAllowanceGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Other Allowance is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }
            if (overtime?.guaranteed && (overtime?.yearMostRecent || overtime.amount) && !uploadData?.overtimeGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Overtime is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }
            if (bonus?.guaranteed && (bonus?.yearMostRecent || bonus.amount) && !uploadData?.bonusGuaranteed) {
                problems.push(new problem({
                    type: "BUNDLE",
                    title: 'Data Mismatch',
                    message: `Bonus is not guaranteed according to Salary Cert`,
                    uploadIDs: [this.activeUpload.id]
                }))
            }


            // check start date of employment on most recent eds vs this salary cert
            const sortedSalaryCerts = [...this.activeUploads.filter(u => u.values.documentDate)].sort((a, b) => b.values.documentDate.valueOf() - a.values.documentDate.valueOf())
            const mostRecentSalaryCert = sortedSalaryCerts[0]
            const mostRecentSalaryCertStartDate = mostRecentSalaryCert.values.employmentStartDate
            const mostRecentSalaryCertPay = mostRecentSalaryCert.values.grossBasicThisYear
            if (mostRecentSalaryCert && mostRecentSalaryCertStartDate) {
                const edsprops = {
                    category: 'employment',
                    name: `employment-summary-${this.applicant}`,
                    title: 'employment details summary',
                    dataType: adminEDSSection,
                    applicant: this.applicant,
                    stage: 'APPLY',
                    type: 'UPLOAD'
                }
                const edsSection = new adminEDSSection(this.request, this.mortgage, edsprops)
                const mostRecentEds = [...edsSection.activeUploads.filter(it => it.values.year)].sort((a, b) => b.values.year - a.values.year)[0]
                if (mostRecentEds) {
                    const startDates = [mostRecentEds?.values?.start1, mostRecentEds?.values?.start2, mostRecentEds?.values?.start3].filter(it => it)

                    if (!startDates.some(date => date.startOf("day").isSame(mostRecentSalaryCertStartDate.startOf("day")))) {
                        const answered = this.mortgage.docContents.find(dc => dc.document === 'coverLetter' && dc.paragraph === `app${this.applicant}SalaryCertEmploymentStartDateMismatch`)?.html
                        const resolved = (answered && convertHtmlToPlainText(answered) !== '')
                        const salCertDate = mostRecentSalaryCertStartDate.format('D MMM YYYY')
                        const edsDates = startDates.map(it => it.format('D MMM YYYY')).join(", ")
                        problems.push(new problem({
                            type: "BUNDLE",
                            name: "EMPLOYMENT_START_DATE_MISMATCH",
                            title: `Employment Start Not Found in EDS`,
                            message: `Salary Cert Start Date (${salCertDate}) not found in EDS (${edsDates})`,
                            uploadIDs: [mostRecentSalaryCert.props.upload.id, mostRecentEds.props.upload.id],
                            resolved
                        }))

                    }
                }

            }

            if (mostRecentSalaryCert && mostRecentSalaryCertPay) {
                // check gross basic against payslip uploads
                const newProps = {
                    data: this.data,
                    title: 'payslips',
                    name: `payslips-${this.applicant}`,
                    applicant: this.applicant,
                    index: this.index,
                    stage: this.stage,
                    category: this.category,
                    dataType: adminPayslipSection
                }
                const paylipsSection = new adminPayslipSection(this.request, this.mortgage, newProps)
                const mostRecentPayslip = [...paylipsSection.activeUploads.filter(it => it.values.documentDate)].sort((a, b) => b.values.documentDate - a.values.documentDate)[0]
                const mortgageRecentPayslipAmount = mostRecentPayslip?.values?.grossBasic || 0
                if (mortgageRecentPayslipAmount) {
                    const frequency = this.data?.payFrequency
                    let yearlyDeduced = 0

                    switch (frequency) {
                        case "MONTHLY":
                            yearlyDeduced = mortgageRecentPayslipAmount * 12
                            break;
                        case "FORTNIGHTLY":
                            yearlyDeduced = mortgageRecentPayslipAmount * 26.09
                            break;
                        case "WEEKLY":
                            yearlyDeduced = mortgageRecentPayslipAmount * 52
                            break;
                    }

                    if (yearlyDeduced && mostRecentSalaryCertPay) {
                        const diff = mostRecentSalaryCertPay - yearlyDeduced

                        if (Math.abs(diff) >= 5) {
                            const way = diff < 0 ? "less" : "more"
                            const answered = this.mortgage.docContents.find(dc => dc.document === 'coverLetter' && dc.paragraph === `app${this.applicant}SalaryCertGrossBasicMismatch`)?.html
                            const resolved = (answered && convertHtmlToPlainText(answered) !== '')

                            problems.push(new problem({
                                type: "BUNDLE",
                                name: "GROSS_BASIC_MISMATCH",
                                title: `Gross Basic/Salary Cert Mismatch- ${diff} ${way}`,
                                message: `Salary Cert Gross Basic (${mostRecentSalaryCertPay}) doesnt match the payslip data (${yearlyDeduced}) - ${Math.abs(diff)} ${way}`,
                                uploadIDs: [mostRecentPayslip.props.upload.id, mostRecentSalaryCert.props.upload.id],
                                resolved
                            }))

                        }
                    }

                }
            }

        }
        return problems
    }

    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Document Date',
                        value: this.documentDate ? this.documentDate.format('D MMM YYYY') : 'N/A'
                    },
                    {
                        name: 'Gross Basic',
                        value: this.activeUpload?.values?.grossBasicThisYear ? this.activeUpload.values.grossBasicThisYear : 'N/A'
                    }
                ]
            }
        ]
    }
}